<template>
	<div class="search-container">
		<div class="section">
			<div class="section-header">
				<div class="title">
					<span>搜索发现</span>
					<div class="bottom"></div>
				</div>
				<i
					@click="nextSix"
					v-if="hotWords.length > pageSize"
					class="iconfont icon-shuaxin clear-his"
					style="color: #86909c; font-weight: 300"
				></i>
			</div>
			<div class="discover-list" v-if="hotWords.length > 0">
				<div class="discover-item" @click="clickItem(item)" v-for="(item, index) in displayedHotWords" :key="index">{{ item.hotWords }}</div>
			</div>
			<div v-else class="no-his">暂无数据</div>
		</div>
	</div>
</template>
<script >
export default {
	props: {
		hotWords: {
			type: Array,
			default: () => [],
		},
	},
	data() {
		return {
			pageIndex: 0,
			pageSize: 6,
		};
	},
	computed: {
		displayedHotWords() {
			const start = this.pageIndex * this.pageSize;
			return this.hotWords.slice(start, start + this.pageSize);
		},
	},
	methods: {
		clickItem(item) {
			this.$emit('clickItem', item);
		},
		nextSix() {
			const max = Math.ceil(this.hotWords.length / this.pageSize);
			this.pageIndex = this.pageIndex + 1;
			if (this.pageIndex >= max) {
				this.pageIndex = 0;
			}
		},
	},
};
</script>
<style lang="scss" scoped>
.no-his {
	text-align: center;
	padding: 4px;
}
.search-container {
	background: #fff;
	border-radius: 6px;
	width: 380px;
	background: #fff;
	padding: 0px 12px;
	margin-top: 12px;
}

.section-header {
	display: flex;
	justify-content: space-between;
	align-items: center;
	font-weight: bold;
	color: #333;
	font-size: 14px;
	margin-bottom: 10px;
	height: 40px;
	.title {
		display: flex;
		align-items: center;
		flex-direction: column;
		.bottom {
			width: 58px;
			height: 5px;
			background: linear-gradient(90deg, #6696fd -16%, #bbf9fd 95%);
		}
	}
}

.section-header i {
	display: inline-block;
	padding: 3px;
	margin-right: 8px;
	font-size: 16px;
}

/* 搜索历史标签 */
.history-tags {
	display: flex;
	flex-wrap: wrap;
	gap: 6px;
	margin-bottom: 20px;
}

.tag {
	display: inline-block;
	background: #f2f3f5;
	color: #333;
	border-radius: 4px;
	padding: 4px 10px;
	font-size: 13px;
	cursor: pointer;
	transition: background 0.2s;
}

.tag:hover {
	background: #e8e9eb;
}

/* 搜索发现 */
.discover-list {
	display: flex;
	flex-wrap: wrap;
	gap: 14px 12px;
}

.discover-item {
	width: calc(50% - 6px);
	display: flex;
	align-items: flex-start;
	line-height: 16.8px;
	font-size: 14px;
	cursor: pointer;
	color: #333;
	transition: color 0.2s;
}

.discover-item:hover {
	color: #409eff;
}

.index {
	display: inline-block;
	width: 18px;
	height: 18px;
	text-align: center;
	line-height: 16.8px;
	border-radius: 2px;
	background: #f0f2f5;
	margin-right: 6px;
	font-size: 12px;
	color: #595959;
}
.index.active {
	background: #7aa2fd;
	color: #fff;
}
</style>